import axios from 'axios';
import LightStorage from "light-storage";

const API_URL = process.env.VUE_APP_API_URL;
const APP_PREFIX = process.env.VUE_APP_APP_PREFIX;

export const storage = new LightStorage(APP_PREFIX);

axios.defaults.baseURL = API_URL;

if(storage.get('token')){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + storage.get('token');
}

export const api = axios;